import React from "react";
import {useEffect, useState} from "react";
import {companyService} from "../../../services";
import {Button, Modal, notification, Row, Spin} from "antd";
import i18n from "../../../i18n";

export default function ModalRequestAllowInternational({
                                                         isShow,
                                                         setIsShow,
                                                         delivery,
                                                         setNeedUpdateDeliveryList,
                                                         setStopListUpdate,
                                                       }) {
  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [listCompanies, setListCompanies] = useState([]);
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showOrderToShipperCompanyModal, setShowOrderToShipperCompanyModal] = useState(false);
  const [legalEntityId, setLegalEntityId] = useState(null);
  const currentShipperCompanyId = delivery.CustomerCompanyId;

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };

  let bigButtonCancelStyle = {
    width: '200px', height: '43px', background: '#BE1C1C', position: 'static', borderRadius: '10px'
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };


  useEffect(() => {
    if (listCompanies && listCompanies.length) {
      setLoadingContentModal(false);
    }
  }, [listCompanies]);


  const getFieldErrors = (nameField) => {

    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const onSignUp = () => {
    companyService.requestAllowInternational(currentShipperCompanyId)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.requestAllowInternational'),
          description: response.message,
        });
        setIsShow(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.requestAllowInternational'),
          description: err,
        });
      })
      .finally(() => {
      })
  }

  let content;

  const closeModal = () => {
    setIsShow(false);
    setNeedUpdateDeliveryList(false);
    setStopListUpdate(false);
  }

  if (errorMsg) {
    content = (<div className="content-error-block">{errorMsg}</div>);
  } else {
    content = (
      <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{i18n.t('modals.modalRequestAllowInternational.text')} <span>{delivery.CustomerCompany}</span></h2>
        </Row>
      </Spin>
    );
  }

  return (
    <>
      <Modal
        title={i18n.t('modals.modalRequestAllowInternational.title')}
        okText={i18n.t('modals.modalRequestAllowInternational.buttons.submit')}
        cancelText={i18n.t('main.buttons.close')}
        className="modal-window"
        align={null}
        visible={isShow}
        onCancel={() => {
          setIsShow(false);
          setNeedUpdateDeliveryList(false);
          setStopListUpdate(false);
        }}
        footer={[
          (errorMsg === null) ?
            <Button htmlType="button" disabled={loadingContentModal} style={bigButtonStyle} key="submit" type="primary"
                    onClick={() => onSignUp()}>{i18n.t('main.buttons.send')}</Button>
            : null,
          <Button onClick={() => closeModal()} htmlType="button" style={bigButtonCancelStyle}
                  type="primary">{i18n.t('modals.modalRequestAllowInternational.buttons.cancel')}</Button>]}
      >
        {content}
      </Modal>
    </>
  );
}
